import React from 'react';
import TarifDetails from '../components/TarifDetails';



const Tarifs = () => {
    return (
     <div>

        <TarifDetails />

     </div>
   
     );
    }
    
    export default Tarifs